/** Created by azhou on 2019/4/1.*/
<template>
  <ul class="list-item">
    <li class="w-50 list-item-col">{{Itemize.order_type| formatVar('OrderType')}}</li>
    <li class="w-50 list-item-col">{{Itemize.travel_title}}</li>
    <li class="w-50 list-item-col">{{Itemize.date_in | formatTimestamp}}-{{Itemize.date_out | formatTimestamp}}</li>
    <li class="w-50 list-item-col">{{Itemize.num}} 人</li>
    <li class="w-50 list-item-col" v-if="Itemize.end_time==0">暂无</li>
    <li class="w-50 list-item-col" v-else>{{Itemize.end_time | formatTimestamp(1)}}</li>
    <li class="w-50 list-item-col">{{Itemize.status | formatVar('TOrderStatus')}}</li>
  </ul>
</template>

<script>

  export default {
    name: 'ItemizeTravel',
    props:{
      Itemize:{}
    },
    computed:{
      orderStatus() {
        switch (Number(this.Itemize.order_style)) {
          case 3:
          case 5: return 'TOrderStatus';
          case 6: return 'SOrderStatus';
          default:return ''
        }
      }
    }
  }
</script>
